import { cn } from "@/utils/classes";
import { ReactNode } from "react";

/* Prop Types */
interface TableHeaderProps {
  className?: string;
  children?: ReactNode;
}

/*
 * TableHeader component
 */
export const TableHeader = ({ className, children }: TableHeaderProps) => {
  /* Render */
  return (
    <th className={cn("select-none sticky top-0 bg-base-200 px-4 py-2 z-10 first:rounded-tl-lg last:rounded-tr-lg", className)}>
      <div className="flex flex-row items-center font-bold text-sm text-base-content/60 tracking-wide">{children}</div>
    </th>
  );
};
